module.exports = __webpack_public_path__ + "static/media/SuccessIcon.c12f80ec.svg";